import { useState } from 'react';
import { AUTOMATIC_PRESENTATIONS, useAutomaticPresentation } from '#shared/lib/automaticPresentation';
import { useCommunicationContext } from './CommunicationContext';
import { type ModalCommunication } from './selectModalCommunication';

export const useCommunicationModal = () => {
    const { modal, isPending, close, action } = useCommunicationContext();
    // Сохраняем содержимое закрывающегося окна до конца анимации, даже если уже выбран следующий кандидат.
    const [leavingModal, setLeavingModal] = useState<ModalCommunication>();
    const communication = leavingModal ?? modal;
    const eligibility = communication ? 'eligible' : 'ineligible';
    const presentation = useAutomaticPresentation({
        ...AUTOMATIC_PRESENTATIONS.NORMAL.communicationModal,
        // Следующая коммуникация создаёт новую регистрацию после завершения предыдущего показа.
        id: `${AUTOMATIC_PRESENTATIONS.NORMAL.communicationModal.id}.${communication?.id ?? 'pending'}`,
        eligibility: isPending ? 'pending' : eligibility,
    });

    const onClose = () => {
        if (!communication) {
            return;
        }

        if (presentation.startLeaving('dismissed')) {
            setLeavingModal(communication);
            close(communication.id);
        }
    };

    const onAction = () => {
        if (!communication) {
            return;
        }

        const shouldClose = action(communication);

        if (shouldClose && presentation.startLeaving('completed')) {
            setLeavingModal(communication);
        }
    };

    const completeLeaving = () => {
        if (presentation.completeLeaving()) {
            setLeavingModal(undefined);
        }
    };

    return {
        communication,
        isOpen: presentation.isActive,
        onClose,
        onAction,
        completeLeaving,
    };
};
